"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasheetOperationPermission = exports.CollectType = exports.RollUpFuncType = exports.RuntimeEnv = exports.InstallPosition = exports.WidgetMountType = exports.WidgetType = exports.Conversion = exports.SymbolAlign = exports.TimeFormat = exports.DateFormat = exports.StatType = exports.BasicValueType = void 0;
var core_1 = require("../core");
Object.defineProperty(exports, "BasicValueType", { enumerable: true, get: function () { return core_1.BasicValueType; } });
Object.defineProperty(exports, "StatType", { enumerable: true, get: function () { return core_1.StatType; } });
Object.defineProperty(exports, "DateFormat", { enumerable: true, get: function () { return core_1.DateFormat; } });
Object.defineProperty(exports, "TimeFormat", { enumerable: true, get: function () { return core_1.TimeFormat; } });
Object.defineProperty(exports, "SymbolAlign", { enumerable: true, get: function () { return core_1.SymbolAlign; } });
Object.defineProperty(exports, "Conversion", { enumerable: true, get: function () { return core_1.Conversion; } });
var WidgetType;
(function (WidgetType) {
    WidgetType["Chart"] = "chart";
    WidgetType["Summary"] = "summary";
})(WidgetType = exports.WidgetType || (exports.WidgetType = {}));
var WidgetMountType;
(function (WidgetMountType) {
    WidgetMountType["Part"] = "part";
    WidgetMountType["Full"] = "Full";
})(WidgetMountType = exports.WidgetMountType || (exports.WidgetMountType = {}));
var InstallPosition;
(function (InstallPosition) {
    InstallPosition["WidgetPanel"] = "WidgetPanel";
    InstallPosition["Dashboard"] = "Dashboard";
})(InstallPosition = exports.InstallPosition || (exports.InstallPosition = {}));
var RuntimeEnv;
(function (RuntimeEnv) {
    RuntimeEnv["Mobile"] = "Mobile";
    RuntimeEnv["Desktop"] = "Desktop";
})(RuntimeEnv = exports.RuntimeEnv || (exports.RuntimeEnv = {}));
var RollUpFuncType;
(function (RollUpFuncType) {
    /** No operation */
    RollUpFuncType["VALUES"] = "VALUES";
    /** Average value */
    RollUpFuncType["AVERAGE"] = "AVERAGE";
    /** Non-null value count */
    RollUpFuncType["COUNT"] = "COUNT";
    /** Non-null count */
    RollUpFuncType["COUNTA"] = "COUNTA";
    /** Full Count */
    RollUpFuncType["COUNTALL"] = "COUNTALL";
    /** Find the total */
    RollUpFuncType["SUM"] = "SUM";
    /** Minimum value */
    RollUpFuncType["MIN"] = "MIN";
    /** Maximum value */
    RollUpFuncType["MAX"] = "MAX";
    /** And operation */
    RollUpFuncType["AND"] = "AND";
    /** Or operation */
    RollUpFuncType["OR"] = "OR";
    /** eXclusive OR operation */
    RollUpFuncType["XOR"] = "XOR";
    /** CONCATENATE */
    RollUpFuncType["CONCATENATE"] = "CONCATENATE";
    /** Comma Link as text */
    RollUpFuncType["ARRAYJOIN"] = "ARRAYJOIN";
    /** Remove duplicates */
    RollUpFuncType["ARRAYUNIQUE"] = "ARRAYUNIQUE";
    /** Remove nils */
    RollUpFuncType["ARRAYCOMPACT"] = "ARRAYCOMPACT";
})(RollUpFuncType = exports.RollUpFuncType || (exports.RollUpFuncType = {}));
var CollectType;
(function (CollectType) {
    CollectType[CollectType["AllFields"] = 0] = "AllFields";
    CollectType[CollectType["SpecifiedFields"] = 1] = "SpecifiedFields";
})(CollectType = exports.CollectType || (exports.CollectType = {}));
// Permission to manipulate the contents of a datasheet using a hook.
var DatasheetOperationPermission;
(function (DatasheetOperationPermission) {
    DatasheetOperationPermission[DatasheetOperationPermission["AddRecord"] = 0] = "AddRecord";
    DatasheetOperationPermission[DatasheetOperationPermission["EditRecord"] = 1] = "EditRecord";
    DatasheetOperationPermission[DatasheetOperationPermission["DeleteRecord"] = 2] = "DeleteRecord";
    DatasheetOperationPermission[DatasheetOperationPermission["AddField"] = 3] = "AddField";
    DatasheetOperationPermission[DatasheetOperationPermission["EditFieldName"] = 4] = "EditFieldName";
    DatasheetOperationPermission[DatasheetOperationPermission["EditFieldProperty"] = 5] = "EditFieldProperty";
    DatasheetOperationPermission[DatasheetOperationPermission["DeleteField"] = 6] = "DeleteField";
})(DatasheetOperationPermission = exports.DatasheetOperationPermission || (exports.DatasheetOperationPermission = {}));
